import { createActionTypes } from "../../helpers/utils/createActionTypes";

export const SNIPPETS = {
    GET_LIST_SNIPPET: createActionTypes("GET_LISTA_SNIPPET"),
    GET_SNIPPET: createActionTypes("GET_SNIPPET"),
    SAVE_SNIPPET: createActionTypes("SAVE_SNIPPET"),
    DUPLICATE_SNIPPET: createActionTypes("DUPLICATE_SNIPPET"),

    GET_SNIPPET_HISTORY_LIST: createActionTypes("GET_SNIPPET_HISTORY_LIST"),
    GET_SNIPPET_HISTORY: createActionTypes("GET_SNIPPET_HISTORY"),
    GET_SNIPPET_ALL: createActionTypes("GET_SNIPPET_ALL"),

    GET_SNIPPET_PRODUCTS: createActionTypes("GET_SNIPPET_PRODUCTS"),
    GET_SNIPPET_SECTIONS: createActionTypes("GET_SNIPPET_SECTIONS"),

    GET_SNIPPET_PREVIEW: createActionTypes("GET_SNIPPET_PREVIEW"),

    POST_SNIPPET_DOWNLOAD_LIST: createActionTypes("POST_SNIPPET_DOWNLOAD_LIST"),

    LOAD_EMPTY: "LOAD_EMPTY_SNIPPET",
    CLEAN_MESSAGE: "CLEAN_MESSAGE_SNIPPET",
    CLEAN_ID_SNIPPET_DUPLICATE: "CLEAN_ID_SNIPPET_DUPLICATE",
    CHANGE_PAGE_SIZE_SNIPPET: "CHANGE_PAGE_SIZE_SNIPPET",
}